import { Component, Input } from '@angular/core'
import { BsModalRef } from 'ngx-bootstrap/modal'
import { ButtonModule } from 'primeng/button'

@Component({
   selector: 'vc-rules-engine-modal',
   templateUrl: './rules-engine-modal.component.html',
   styleUrl: './rules-engine-modal.component.scss',
   standalone: true,
   imports: [ButtonModule],
})
export class RulesEngineModalComponent {
   @Input() title: string
   @Input() message: string
   @Input() onConfirm: () => void
   @Input() onCancel: () => void

   constructor(private modalRef: BsModalRef) {}

   close() {
      this.modalRef.hide()
      if (this.onCancel) {
         this.onCancel()
      }
   }

   confirm() {
      this.modalRef.hide()
      if (this.onConfirm) {
         this.onConfirm()
      }
   }
}
